const functionDetails = (execution, functionDetails, payload) => {
  window.execution = execution
  window.functionDetails = functionDetails
  window.payload = payload
}

export default functionDetails



// WEBPACK FOOTER //
// ./src/utils/functionDetails.js